/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgSecurityWafSolid = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.5 2.25h4.75v2H1.5v-2zM1.5 9h4.75v2.25H1.5V9zm7-3.5H3.75v2.25H8.5V5.5zm-4.75 7H8.5v2.25H3.75V12.5zm8.5-10.25H7.5v2h4.75v-2zM7.5 9h4.75v2.25H7.5V9zm7-3.5H9.75v2.25h4.75V5.5zm-4.75 7h4.75v2.25H9.75V12.5z"
}));

export default SvgSecurityWafSolid;